import { Flex, Spinner, Text } from "@chakra-ui/react";
import {
  CONFIRMED_COLOR,
  ORDERED_COLOR,
} from "@/features/line-sheet-sets/detail/line-sheet-order-sheet-table";

/**
 * 주문 값(위, 초록)·확정 값(아래, 파랑)을 두 줄로 보여주는 셀 — 펼친 오더 표의 칸과 같은 모양.
 * 확정 전이면 아래 줄에 '미확정'. 값이 없으면 '-', 아직 불러오는 중이면 스피너.
 */
export default function OrderedConfirmedCell({
  ordered,
  confirmed,
  unconfirmedLabel,
  isLoading = false,
}: {
  ordered?: string;
  confirmed?: string;
  unconfirmedLabel: string;
  // 오더 정보를 불러오는 중 — 값이 없다는 뜻의 '-' 와 구분되게 스피너를 보여준다
  isLoading?: boolean;
}) {
  if (ordered === undefined) {
    return (
      <Flex width={"100%"} justifyContent={"flex-end"} paddingRight={"8px"}>
        {isLoading ? (
          <Spinner size={"xs"} color={"#8F8F8C"} />
        ) : (
          <Text color={"#8F8F8C"}>-</Text>
        )}
      </Flex>
    );
  }
  return (
    <Flex
      width={"100%"}
      flexDirection={"column"}
      alignItems={"flex-end"}
      paddingRight={"8px"}
      whiteSpace={"nowrap"}
    >
      <Text color={ORDERED_COLOR}>{ordered}</Text>
      <Text color={CONFIRMED_COLOR}>{confirmed ?? unconfirmedLabel}</Text>
    </Flex>
  );
}
